import brand from '@helpers/brand';
import { Layers } from '@helpers/layers';
import { m } from 'framer-motion';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled(m.section) `
  --bgColor: ${brand.white};
  --fgColor: ${brand.black};
  --tintColor: ${rgba(brand.black, 0.89)};

  position: fixed;
  top: 0;
  left: 0;
  display: grid;
  color: var(--fgColor);
  height: 100%;
  place-content: center;
  place-items: center;
  width: 100%;
  z-index: ${Layers.Modal};

  &[data-open='false'] {
    display: none;
  }
`;
const Inner = styled(m.div) `
  position: relative;
  height: 100vh;
  padding-bottom: 116px;
  padding-top: 72px;
`;
const ModalStyles = {
    Container,
    Inner,
};
export default ModalStyles;
